import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title: string;
    description: string;
    keywords?: string;
    image?: string;
    url?: string;
    type?: 'website' | 'article' | 'business.business';
}

const SEO: React.FC<SEOProps> = ({
    title,
    description,
    keywords,
    image = 'https://www.singhsbestbuy.com/og-image.jpg', // Default image needed
    url = 'https://www.singhsbestbuy.com',
    type = 'website'
}) => {
    const siteTitle = "Singh's Best Buy | Gurgaon's Trusted Real Estate Aggregators";
    const fullTitle = title === siteTitle ? title : `${title} | Singh's Best Buy`;

    // Default keywords if none provided
    const defaultKeywords = "Real Estate Gurgaon, Luxury Apartments, Property in Dehradun, Plots in Haridwar, Mussoorie Cottages, Singh's Best Buy";
    const metaKeywords = keywords ? `${keywords}, ${defaultKeywords}` : defaultKeywords;

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={metaKeywords} />
            <link rel="canonical" href={url} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={url} />
            <meta property="og:site_name" content="Singh's Best Buy" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
};

export default SEO;
